import React, { useEffect, useState } from "react";
import { Page } from "components/common";
import { Row, Col, Button } from "reactstrap";
import { NotificationManager } from "react-notifications";
import { FormGroup } from "components/common/Forms";
import { LocalForm, Control } from "react-redux-form";
import GetBack from "components/refactoring/BackButton";
import { Trans, useTranslation } from "react-i18next";
import { ZatcaClient } from "services";

const Renew = ({match}) => {
    const { id } = match.params;

    const { t } = useTranslation();

    const zatca = ZatcaClient();
    const [data, setData] = useState();

    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await zatca.get(`sdk/${id}`);
            setData(response.data);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchData();
      }, []);

    const handleRenewal = (values) => {
        setIsSending(true)
        const { otp, otp2 } = values;
        const simplifiedValues = { otp, otp2 };

        zatca.post(`sdk/${id}`, simplifiedValues)
            .then(response => {
                setIsSending(false)
                NotificationManager.success("OTP Sent Successfully");
            })
            .catch(error => {
                setIsSending(false)
                NotificationManager.error("Error occurred while saving");
            });
    };

    return (
        <Page title={t("Zatca Onboarding For E-Invoicing")} className="inv-table">
            <GetBack />
            <LocalForm onSubmit={values => handleRenewal(values)}>
                <div className="text-center my-3" style={{ fontSize: "1.2em" }}>
                    <span>
                        <Trans>Welcome to Zatca Integration of Hesaab, Please Log in to your
                            <a href="https://fatoora.zatca.gov.sa/" target="_blank" className="text-success"> Fatoora Portal </a>
                            and generate two OTP's for Renewal.
                        </Trans>
                    </span>
                </div>
                <div className="mb-4 alert alert-info" role="alert">
                    <Row>
                        <Col className="col-md-6 py-1">
                            <FormGroup label={t("OTP 1*")} model=".otp">
                                <Control.text model=".otp" placeholder="123345" maxLength="6" />
                            </FormGroup>
                        </Col>
                        <Col  className="col-md-6 py-1">
                            <FormGroup label={t("OTP 2*")} model=".otp2">
                                <Control.text model=".otp2" placeholder="123345" maxLength="6" />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
                <div className="tw-flex my-4">
                    {!isSending ?
                        <Button color="primary"> <Trans>Renew</Trans></Button>
                        :
                        <Button color="primary" disabled><span className="fa fa-spinner fa-spin" /> <Trans>Renewing</Trans></Button>
                    }
                </div>
            </LocalForm>
        </Page>
    );
};

export default Renew;
